import { StorageRounded } from "@mui/icons-material";

export const storage = (props) => {
  return <StorageRounded {...props} />;
};
